export default __webpack_public_path__ + "static/media/star.7690fed1.svg";